import http from '@/util/http'

class ReceiverManageApi {
  //查询接口
  list (data) {
    let url = '/share-foreign/receive/list'
    return http.post (url, data)
  }
  //查询接口（分页）
  listPage (data) {
    let url = '/share-foreign/receive/listPage'
    return http.post (url, data)
  }
  //添加接口
  addPerson (data) {
    let url = '/share-foreign/receive/addPerson'
    return http.post (url, data)
  }
  //修改接口
  updatePerson (data) {
    let url = '/share-foreign/receive/updatePerson'
    return http.post (url, data)
  }
  //删除接口
  delete (data) {
    let url = '/share-foreign/receive/delete'
    return http.post (url, data)
  }
  //详情接口
  detail (data) {
    let url = '/share-foreign/receive/detail'
    return http.post (url, data)
  }
  //上线/下线
  changeStatus (data) {
    let url = '/share-foreign/receive/changeStatus'
    return http.post (url, data)
  }
}

export default ReceiverManageApi
